// extracted by mini-css-extract-plugin
export default {"stats":"ClientCard_stats__3cpuS","redFlash":"ClientCard_redFlash__2xrJJ","financialTitle":"ClientCard_financialTitle__VB8Lw","clientHeader":"ClientCard_clientHeader__1nhfo"};